import styled from "@emotion/styled";
import { media } from "../../components/Window/themes";
const PaginationItem = {
    Wrapper: styled.div `
    align-items: center;
    justify-content: space-between;
    padding-left: 4;
    padding-right: 4;
    align-self: stretch;
    ${media.medium} {
      padding-left: 1rem;
    }
  `,
    Text: styled.p `
    font-size: small;
    color: gray;
  `,
    HStack: styled.div `
    position: relative;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    gap: 0.25rem;
    vertical-align: middle;
    margin-top: 0.75rem;
    margin-bottom: 0.25rem;
  `,
    Button: styled.button `
    cursor: pointer;
    color: ${({ theme }) => theme.color.backgroundBrand};
    background-color: transparent;
    background-image: none;
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid ${({ theme }) => theme.color.backgroundBrand};
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    &:not(:disabled):hover {
      color: #fff;
      background-color: ${({ theme }) => theme.color.backgroundBrand};
      border-color: ${({ theme }) => theme.color.backgroundBrand};
    }
    &:disabled {
      opacity: 0.5;
    }
    ${media.medium} {
      font-weight: 200 !important;
      font-size: 0.8rem !important;
      padding: 0.175rem 0.35rem;
    }
  `,
    Select: styled.select `
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    display: inline-block;
    height: calc(2.25rem + 2px);
    padding: 0.375rem 0.3rem 0.375rem 0.75rem;
    line-height: 1.5;
    color: #495057;

    &:focus {
      border-color: ${({ theme }) => theme.color.backgroundBrand};
      outline: 0;
      box-shadow: inset 0 1px 2px rgb(0 0 0 / 8%), 0 0 5px rgb(228 86 116);
    }
    ${media.medium} {
      font-weight: 200 !important;
      font-size: 0.8rem !important;
      padding: 0.175rem 0.35rem;
    }
  `,
};
export default PaginationItem;
//# sourceMappingURL=Pagination.styled.js.map